import './css/App.css';
import { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';


//Components

import LoadingSpinner from './components/loadingSpinner/LoadingSpinner';
import ScrollToTop from './ScrollTopTop';

import Navbar from './components/mainComponents/navBar';
import NavBarBottom from './components/mainComponents/navBarBottom';
import Hamburger from './components/mainComponents/hamburger';

import Home from './components/bodyComponents/Home';
import Plans from './components/bodyComponents/Plans';
import GetStarted from './components/bodyComponents/GetStarted';
import GetStartedWizard from './components/bodyComponents/GetStarted/GetStartedWizard';
import Demo from './components/bodyComponents/Demo';
import DemoVideo from './components/bodyComponents/DemoVideo';
import Setup from './components/bodyComponents/Setup';

import TermsOfUse from './components/bodyComponents/legal/TermsOfUse';
import PrivacyPolicy from './components/bodyComponents/legal/PrivacyPolicy';

import NotFound from './components/bodyComponents/NotFound';


function App() {


  const location = useLocation();

  // 🔥 Google Analytics Page Tracking
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-L14W4D7TW9', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);


  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [colors, setColors] = useState({})




  // Update screenWidth on window resize
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [isNavOpen, setIsNavOpen] = useState(false);


  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };


  return (

    <div className="app">

      <Navbar isNavOpen={isNavOpen} toggleNav={toggleNav} />

      <Hamburger isNavOpen={isNavOpen} toggleNav={toggleNav} />

      <ScrollToTop />
      <Routes>
        {/* Public routes */}

        <Route path="/" element={<Home isNavOpen={isNavOpen} />} />

        <Route path="/plans" element={<Plans isNavOpen={isNavOpen} />} />

        <Route path="/demo" element={<Demo isNavOpen={isNavOpen} />} />

        <Route path="/demo/video" element={<DemoVideo isNavOpen={isNavOpen} />} />

        <Route path="/start" element={<GetStartedWizard isNavOpen={isNavOpen} />} />

        <Route path="/setup" element={<Setup isNavOpen={isNavOpen} />} />

        <Route path="/legal/terms" element={<TermsOfUse isNavOpen={isNavOpen} />} />

        <Route path="/legal/privacy" element={<PrivacyPolicy isNavOpen={isNavOpen} />} />

        <Route path="*" element={<NotFound isNavOpen={isNavOpen} />} />
      </Routes>

      <NavBarBottom isNavOpen={isNavOpen} toggleNav={toggleNav} />

    </div>

  );
}




export default App;
